import React from 'react';
import { Button } from 'react-bootstrap';
import styles from './ShareBox.scss';

function openUrl(prefix) {
  var url = window.location.href;

  if (url.indexOf('?') !== -1) {
    url = url.split('?')[0];
  }

  url = url.replace('#', '?path=');
  window.open(prefix + url);
}

export default function ShareBox(props) {
  return React.createElement('div', {
    className: styles.shareBox
  }, React.createElement(Button, {
    style: {
      background: '#3e5b98',
      borderColor: '#136'
    },
    onClick: function onClick() {
      return openUrl('http://www.facebook.com/sharer.php?u=');
    }
  }, React.createElement('span', {
    className: 'socicon-facebook'
  })), React.createElement(Button, {
    style: {
      background: '#4da7de',
      borderColor: '#269'
    },
    onClick: function onClick() {
      return openUrl('http://twitter.com/share?url=');
    }
  }, React.createElement('span', {
    className: 'socicon-twitter'
  })), React.createElement(Button, {
    style: {
      background: '#3371b7',
      borderColor: '#148'
    },
    onClick: function onClick() {
      return openUrl('http://www.linkedin.com/shareArticle?mini=true&url=');
    }
  }, React.createElement('span', {
    className: 'socicon-linkedin'
  })), React.createElement(Button, {
    style: {
      background: '#dd4b39',
      borderColor: '#922'
    },
    onClick: function onClick() {
      return openUrl('https://plus.google.com/share?url=');
    }
  }, React.createElement('span', {
    className: 'socicon-googleplus'
  })));
}